export default "__VITE_ASSET__BAk8Li7Q__"